import { axiosInstance } from "@hopper-b2b/api";

export const apiVersionPrefix = "/api/v0";
export const authPrefix = `${apiVersionPrefix}/auth`;
export const startSessionPath = `${authPrefix}/startSession`;
export const elevatePath = `${authPrefix}/elevateSession`;
export const sessionInfoPath = `${authPrefix}/getInfo`;
export const updatePhoneNumberPath = `${authPrefix}/updatePhoneNumber`;

export interface PerkspotUserInfoResponse {
  email: string;
  firstName: string;
  lastName: string;
  hardAuth: boolean;
  pointsBalance?: number;
  tenantUserId: string;
  elevateLink?: string;
  communityId: number;
  phoneOpt?: string;
  eligibility: {
    carBrands?: {
      id: number;
      name: string;
    }[];
    categories?: {
      id: number;
      name: string;
    }[];
    enableCarBooking?: boolean;
  };
}

export interface PerkspotSessionInfo {
  hopperSessionToken?: string;
  hopperUserId: string;
  isImpersonation?: boolean;
  userDetails: PerkspotUserInfoResponse;
  error?: string;
}

export interface StartSessionRequest {
  code: string;
  initiator?: string;
}

export const startSession = (code: string): Promise<PerkspotSessionInfo> => {
  const reqBody = {
    code: code,
  };
  return axiosInstance.post(startSessionPath, reqBody).then((res) => res.data);
};

export const elevateSession = (code: string): Promise<PerkspotSessionInfo> => {
  const reqBody = {
    code: code,
  };
  return axiosInstance.post(elevatePath, reqBody).then((res) => res.data);
};

export const fetchSessionInfo = (): Promise<PerkspotSessionInfo> => {
  return axiosInstance.get(sessionInfoPath).then((res) => res.data);
};

export const updatePhoneNumber = (
  phoneNumber: string
): Promise<PerkspotSessionInfo> => {
  return axiosInstance
    .put(updatePhoneNumberPath, { phoneNumber })
    .then((res) => res.data);
};
